import styled, { keyframes, css } from 'styled-components';
import { Form } from '@unform/web';
import { TabPanel } from '@chakra-ui/react';

interface SenhaPARAMS {
  visibility: boolean;
}

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(600px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;
const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 7;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;

  .active {
    opacity: 1;
    visibility: visible;
    right: 0px;
    animation: ${appearFromLeft} 0.5s;

    @media (max-width: 650px) {
      top: 0px;
      animation: ${appearFromTop} 0.5s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  background-color: #fff;
  position: fixed;
  right: -450px;
  width: 700px;
  height: 100%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  border-radius: 3px;
  padding: 0 20px;
  transition: all 0.5s ease-out;

  .tabs {
    width: 100%;
    height: 100%;
    padding-top: 10px;

    .tab-list {
      display: flex;
      justify-content: space-between;

      .tab {
        font-size: 18px;
        font-weight: 500;
        width: 100%;

        :focus {
          box-shadow: 0 0 0 0;
          border: 0 0;
        }
      }
    }

    .tab-panels {
      width: 100%;
      height: 93.5%;
      position: relative;

      // border: 2px solid orange;

      .tab-panel {
        width: 100%;
        height: 100%;
        padding: 0;

        // border: 2px solid red;
      }
    }
  }

  .radio-group {
    .radio {
      display: flex;
      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
      border-radius: 8px;
      padding: 10px 10px 15px;
      margin-top: 20px;

      .radio-label {
        display: flex;
        align-items: center;

        :last-child {
          margin-top: 10px;
        }

        input[type='radio'] {
          margin-right: 10px;
          appearance: none;
          font: inherit;
          color: var(--azul-razio);
          width: 18px;
          height: 18px;
          border: 2px solid var(--gray-border-lw);
          border-radius: 50%;

          :checked {
            border: 5px solid var(--azul-razio);
          }
        }

        label {
          font-size: 17px;
        }
      }
    }
  }

  @media (max-width: 850px) {
    right: 0px;
    // top: 800px;
    width: 100%;
    margin-top: 0px;
		padding: 0 10px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;

  h1 {
    font-size: 22px;
    font-weight: 500;
  }
  h2 {
    font-size: 18px;
    font-weight: 500;
    color: #607d8b;
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;
  padding-bottom: 70px;
  width: 100%;

  div.input {
    display: flex;
    flex-direction: column;
    width: 100%;

    p {
      font-size: 1rem;
      font-weight: 500;
      margin: 15px 0 3px;

      span {
        font-size: 0.8rem;
        color: #455a64;
      }
    }
  }
`;

export const ButtonsView = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  position: absolute;
  bottom: 0;
  padding: 10px 30px 10px 0;
  width: 100%;
  // border-top: 2px solid #333;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 500;
    padding: 10px 30px;
    border-radius: 10px;
  }
  button.btn-cancel {
    border: 2px solid var(--red-razio);
    color: var(--red-razio);
    margin-right: 20px;
  }
  button.btn-save {
    border: 2px solid var(--azul-razio);
    background-color: var(--azul-razio);
    padding: 10px 40px;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		padding: 20px 10px 10px;
	}
`;

export const TabNameMail = styled(TabPanel)<SenhaPARAMS>`
  #form-nome-email {
    display: block;
    height: 100%;

		#inputs-password {
			right: -600px;
			// visibility: hidden;
			display: none;
			transition: all 0.5s ease-in-out;
			height: 100%;

			${props =>
			props.visibility &&
			css`
				// visibility: visible;
				height: 100%;
				display: block;
				animation: ${appearFromLeft} 0.5s;
			`}
		}

    /* ${props =>
      props.visibility
        ? css`
            display: none;
          `
        : css`
            // visibility: visible;
            height: 100%;
            display: block;
            animation: ${appearFromLeft} 0.5s;
          `} */
  }

  #form-senha {
    right: -600px;
    // visibility: hidden;
    display: none;
    transition: all 0.5s ease-in-out;
    height: 100%;

    ${props =>
      props.visibility &&
      css`
        // visibility: visible;
        height: 100%;
        display: block;
        animation: ${appearFromLeft} 0.5s;
      `}
  }
`;

export const TabRole = styled(TabPanel)``;

export const TabResumo = styled(TabPanel)`
  .item {
    display: flex;
    flex-direction: column;
    padding: 10px;

    hr {
      background-color: #cfd8dc;
      border: none;
      width: 100%;
      height: 1px;
      margin: 10px 0 10px 0;
    }

    h1 {
      font-size: 18px;
      font-weight: 500;
      color: #607d8b;
    }
    h2 {
      font-size: 18px;
      padding-left: 5px;
    }
  }
`;
